// Centralized asset URLs (logos, photos, press)
export const INSTAGRAM_URL = "https://www.instagram.com/manas_hospital_";

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_mindcare-premium/artifacts/q5c0glo2_Add%20a%20subheading_20251004_011213_0000.png";

export const DOCTORS_IMG_URL =
  "https://customer-assets.emergentagent.com/job_mindcare-premium/artifacts/mpljmv6c_Untitled%20%281%29.png";

export const DR_KAMLESH_IMG =
  "https://customer-assets.emergentagent.com/job_mindcare-premium/artifacts/p0sfv99d_Dr%20Kamlesh%20Shah.png";

export const DR_DHARMIN_IMG =
  "https://customer-assets.emergentagent.com/job_mindcare-premium/artifacts/8o3bcbw5_Dr%20Dharmin%20Shah.png";

// Press / media wall
export const PRESS_VYASAN =
  "https://customer-assets.emergentagent.com/job_mindcare-premium/artifacts/ty0zn0r9_Epaper_71_2025-07-01_18.jpeg";
export const PRESS_SUICIDE_PREV =
  "https://customer-assets.emergentagent.com/job_mindcare-premium/artifacts/ed48k0l7_1000305952-Picsart-AiImageEnhancer.jpg";
export const PRESS_AWARD =
  "https://customer-assets.emergentagent.com/job_mindcare-premium/artifacts/awi0a9c8_IMG_9915.jpg";
export const PRESS_BHAVNAGAR_AWARDS =
  "https://customer-assets.emergentagent.com/job_mindcare-premium/artifacts/67t79c0r_IMG_2222%20%281%29.JPG";
export const PRESS_DOCTORS_CONCLAVE =
  "https://customer-assets.emergentagent.com/job_mindcare-premium/artifacts/0nibend5_ANK_9704.jpg";
export const PRESS_GUJARATI_FEATURE =
  "https://customer-assets.emergentagent.com/job_mindcare-premium/artifacts/ov5wqdt8_IMG-20260131-WA0041.jpg";

// Google Maps embed (Manas Neuropsychiatry Hospital — Kalanala, Bhavnagar)
export const MAPS_EMBED_URL =
  "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d29642.43247815739!2d72.10660827431644!3d21.768490100000005!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395f5a7fcf452d3b%3A0xd6dd2325d74d51f3!2sDr%20Kamlesh%20A%20Shah%20%26%20Dr%20Dharmin%20K%20Shah%20-%20Manas%20Neuropsychiatry%20Hospital%20%7C%20DeAddiction%20Centre%20%26%20Sex%20therapy%20Clinic!5e0!3m2!1sen!2sus!4v1778759207836!5m2!1sen!2sus";

export const DOCTORS = [
  {
    slug: "dr-kamlesh-shah",
    name: "Dr. Kamlesh A. Shah",
    title: "Founder · Senior Consultant",
    qualifications: "MD Neuropsychiatry · MBBS · FIPS · FIAPP",
    speciality: "Neuropsychiatry · Deaddiction Specialist · Sexologist",
    education: ["MBBS & MD — B. J. Medical College, Ahmedabad"],
    affiliations: ["Life Fellow, Indian Psychiatric Society"],
    image: DR_KAMLESH_IMG,
  },
  {
    slug: "dr-dharmin-shah",
    name: "Dr. Dharmin K. Shah",
    title: "Consultant · Interventional Neuropsychiatrist",
    qualifications: "MD Neuropsychiatry · TMS Physician (AIIMS, Delhi) · MBBS · MIPS",
    speciality: "Interventional Neuropsychiatry · Deaddiction Specialist · Sexologist",
    education: [
      "MBBS — Government Medical College, Bhavnagar",
      "MD — SBKS Medical Institute & Research Institute, Vadodara",
      "TMS Physician — AIIMS, New Delhi",
    ],
    affiliations: [
      "Life Ordinary Member, Indian Psychiatric Society",
      "Founder, Vyasan Mukt Campus (Bhavnagar)",
    ],
    publications: [
      "Annals of Indian Psychiatry",
      "Journal of Psychosexual Health",
    ],
    image: DR_DHARMIN_IMG,
  },
];
